export default {
  name: "Global",
  center: {
    lon: -2.9,
    lat: 20.853,
    zoom: 3
  },
  sectors: [
    {
      alias: "Aquaculture",
      name: "Aquaculture",
      types: [
        {
          alias: "Biological Suitability",
          name: "BiologicalSuitability",
          ico: "biological",
          provider: "Thredds_MSP",
          layers: [
            {
              description: "Greater Amberjack",
              name: "amberjack",
              alias: "Seriola dumerilii",
              visible: false,
              hasFuture: false
            },
            {
              description: "Atlantic Salmon",
              name: "atlan_salmon",
              alias: "Salmo salar",
              visible: false,
              hasFuture: false
            },
            {
              description: "Cobia",
              name: "cobia",
              alias: "Rachycentron canadum",
              visible: false
            },
            {
              description: "Meagre",
              name: "meagre",
              alias: "Argyrosomus regius",
              visible: false,
              hasFuture: false
            },
            {
              description: "Gilthead Seabream",
              name: "gilthead",
              alias: "Sparus aurata",
              visible: false,
              hasFuture: false
            },
            {
              description: "European Seabass",
              name: "seabass",
              alias: "Dicentrarchus labrax",
              visible: false,
              hasFuture: false
            },
            {
              description: "Atlantic Bluefin Tuna",
              name: "bluefin_tuna",
              alias: "Thunnus thynnus",
              visible: false,
              hasFuture: false
            }
          ]
        },
        {
          alias: "Structural Suitability",
          name: "StructuralSuitability",
          ico: "structural",
          provider: "Thredds_MSP",
          layers: [
            {
              alias: "Structural Suit. Index",
              name: "structural",
              visible: false
            }
          ]
        },
        {
          alias: "Operational Suitability",
          name: "OperationalSuitability",
          ico: "operational",
          provider: "Thredds_MSP",
          layers: [
            {
              alias: "Operational Suit. Index",
              name: "Hs3",
              visible: false
            }
          ]
        },
        {
          alias: "Fish Farming Opportunities",
          name: "FishFarmingOpportunities",
          ico: "opportunity",
          provider: "Thredds_MSP",
          layers: [
            {
              description: "Greater Amberjack",
              name: "amberjack",
              alias: "Seriola dumerilii",
              visible: false
            },
            {
              description: "Atlantic Salmon",
              name: "atlan_salmon",
              alias: "Salmo salar",
              visible: false
            },
            {
              description: "Cobia",
              name: "cobia",
              alias: "Rachycentron canadum",
              visible: false
            },
            {
              description: "Meagre",
              name: "meagre",
              alias: "Argyrosomus regius",
              visible: false
            },
            {
              description: "Gilthead Seabream",
              name: "gilthead",
              alias: "Sparus aurata",
              visible: false
            },
            {
              description: "European Seabass",
              name: "seabass",
              alias: "Dicentrarchus labrax",
              visible: false
            },
            {
              description: "Atlantic Bluefin Tuna",
              name: "bluefin_tuna",
              alias: "Thunnus thynnus",
              visible: false
            }
          ]
        }
      ]
    },
    {
      name: "Energy",
      alias: "Marine Energy",
      types: [
        {
          alias: "Energy Resource Suit.",
          name: "EnergyResourceSuitability",
          ico: "energy",
          provider: "Thredds_MSP",
          layers: [
            {
              alias: "Wind Resource",
              name: "Wind_resource",
              visible: false,
              hasFuture: true
            },
            {
              alias: "Wave Resource",
              name: "Wave_Resource",
              visible: false,
              hasFuture: true
            }
          ]
        },
        {
          alias: "Structural Suitability",
          name: "StructuralSuitability",
          ico: "structural",
          provider: "Thredds_MSP",
          layers: [
            {
              alias: "Survivability (Wind Devices)",
              name: "Structural_Survivability_(Wind_Devices)",
              visible: false
            },
            {
              alias: "Survivability (Wave Devices)",
              name: "Structural_Survivability_(Wave_Devices)",
              visible: false
            }
          ]
        },
        {
          alias: "Operational Suitability",
          name: "OperationalSuitability",
          ico: "operational",
          provider: "Thredds_MSP",
          layers: [
            {
              alias: "Logistics",
              name: "Logistics",
              visible: false
            }
          ]
        },
        {
          alias: "Consumer Centers",
          name: "ConsumerCenters",
          ico: "centers",
          provider: "Thredds_MSP",
          layers: [
            {
              alias: "Distance to Centers",
              name: "Distance_to_Consumer_Centers",
              visible: false
            }
          ]
        },
        {
          alias: "Renewable Energy Opportunities",
          name: "RenewableEnergyOpportunities",
          ico: "opportunity",
          provider: "Thredds_MSP",
          layers: [
            {
              alias: "Wind Energy",
              name: "Wind_Energy",
              visible: false
            },
            {
              alias: "Wave Energy",
              name: "Wave_Energy",
              visible: false
            },
            {
              alias: "Co-location Opportunities",
              name: "Co-location_opportunities",
              visible: false
            }
          ]
        }
      ]
    }
  ]
};
